// extracted by mini-css-extract-plugin
export var checkbox = "_65-0";
export var circle = "_65-3";
export var horizontalContainer = "_65-7";
export var sm = "_65-5";
export var switch0 = "_65-2";
export var switchDisabled = "_65-8";
export var switchEnabled = "_65-1";
export var textSwitchContainer = "_65-9";
export var textSwitchOption = "_65-a";
export var textSwitchOptionSelected = "_65-b";
export var verticalContainer = "_65-6";
export var xs = "_65-4";